<template>
  <div class="login-wrap">
    <div class="login-con">
      <app-header ref="appHeader" />
      <div class="login-box">
        <div class="login-box-con">
          <h3>大智慧登录</h3>
          <form @keyup.enter.native="login">
            <div class="input-group clearfix">
              <label>
                账
                <i></i>号：
              </label>
              <div class="input-block">
                <el-input v-model="account" placeholder="手机号/邮箱/用户名"></el-input>
              </div>
            </div>
            <div class="input-group clearfix" @keyup.enter.native="login">
              <label>
                密
                <i></i>码：
              </label>
              <div class="input-block">
                <el-input type="password" v-model="password" placeholder="请输入密码"></el-input>
              </div>
              <a href="#" class="fl" @click="forgetPass">忘记密码</a>
            </div>
            <div class="input-group clearfix">
              <label>验证码：</label>
              <div class="input-inline" @keyup.enter="login">
                <el-input v-model="verifyCode"></el-input>
              </div>
              <div class="imgCode">
                <img :src="'data:image/png;base64,'+image" alt width="120px" height="35px" :key="imageIndex"/>
                <a @click="getCaptcha()">刷新</a>
              </div>
            </div>
            <div class="input-group">
              <el-button type="primary" @click.prevent="login">登录</el-button>
              <a href="#" @click="register">注册</a>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="fixfooter">
      <app-footer />
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";
export default {
  name: "login",
  data() {
    return {
      refreshable: true,
      loginable: true,
      image: "",
      imageIndex:0,
      verifyId: "",
      account: "",
      password: "",
      verifyCode: "",
      backurl: this.$route.query.backurl
    };
  },
  created() {
    document.title = "登陆 | 大智慧网上商城";
    // let that = this;
    // document.onkeypress = function(e) {
    //   var keycode = document.all ? event.keyCode : e.which;
    //   if (keycode == 13) {
    //     that.login();// 登录方法名
    //     return false;
    //   }
    // };
    this.getCaptcha();
  },
  methods: {
    getCaptcha() {
      //获取验证码
      if (!this.refreshable) {
        return false;
      }
      this.refreshable = false;
      this.$get("/user/captcha?verifyId=" + this.verifyId)
        .then(response => {
          if (response.code === 0) {
            this.image = response.data.image;
            this.imageIndex ++
            this.verifyId = response.data.verifyId;
          } else {
            this.$global.alert(response.msg);
          }
          this.refreshable = true;
        })
        .catch(err => {
          this.refreshable = true;
          this.$global.alertError();
        });
    },
    login() {
      //登录
      if (!this.loginable) {
        return;
      }
      var params = {
        account: this.account,
        password: this.password,
        verifyId: this.verifyId,
        verifyCode: this.verifyCode,
        backUrl: this.backurl
      };
      if (!this.account) {
        this.$global.alert("请输入账号");
        return false;
      }
      if (!this.password) {
        this.$global.alert("请输入密码");
        return false;
      }
      if (!this.verifyCode) {
        this.$global.alert("请输入验证码");
        return false;
      }
      if (this.verifyCode.length != 4) {
        this.$global.alert("验证码格式不正确");
        return false;
      }
      this.loginable = false;
      this.$post("/user/login", params)
        .then(response => {
          if (response.code === 0) {
            if(this.backurl){
              this.$storage.saveUserName(response.data.userName);
              window.location.href = response.data.backUrl
            }else {
              this.$storage.saveUserName(response.data);
              var redirect = this.$route.query.redirect;
              if (redirect) {
                this.$router.push(redirect);
              } else {
                this.$router.push("/");
              }
            }
          } else {
            this.$global.alertAndWindowClose(response.msg);
          }
          this.loginable = true;
        })
        .catch(err => {
          this.loginable = true;
          this.$global.alertError();
        });
    },
    register() {
      this.$refs.appHeader.register();
    },
    forgetPass() {
      this.$get("/user/forgetPass")
        .then(response => {
          if (response.code === 0) {
            window.location.href = response.data;
          } else {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    }
  },
  components: {
    AppHeader,
    AppFooter
  }
};
</script>
<style lang="scss">
.fl {
  float: left;
}
.fixfooter {
  margin-top: -119px;
}
.login-con {
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 119px;
}
.login-box {
  width: 997px;
  border: 1px solid #dbdbdb;
  height: 475px;
  background: url("~@/assets/images/login/login-bg.jpg") no-repeat center left;
  margin: 50px auto 50px;
  position: relative;
}
.login-box-con {
  position: absolute;
  top: 45px;
  left: 600px;
  width: 400px;
  h3 {
    font-size: 30px;
    color: #727272;
    margin: 30px 0 30px;
  }
  .input-group {
    font-size: 16px;
    margin-bottom: 10px;
    line-height: 32px;
    position: relative;
    color: #707070;
    &:last-child {
      margin-top: 30px;
    }
    label {
      float: left;
      width: 90px;
      text-align: right;
      margin-right: 8px;
      i {
        display: inline-block;
        width: 30px;
      }
    }
    .input-block {
      float: left;
      margin-right: 8px;
      width: 200px;
    }
    .input-inline {
      float: left;
      margin-right: 8px;
      width: 76px;
    }
    .el-input__inner {
      height: 36px;
    }
    .el-button {
      margin: 0 50px 0 100px;
      padding: 10px 30px;
    }
    .input-prompt {
      position: absolute;
      left: 310px;
      width: 210px;
      top: 2px;
      border: 1px solid #ddd;
      background: #fff;
      line-height: 28px;
      text-align: center;
    }
    a {
      color: #6cbae2;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue